import api from "./api";

export async function getAllMissions() {
  const response = await api.get("/missions");
  return response.data;
}

export async function getMission(id) {
  const response = await api.get(`/missions/${id}`);
  return response.data;
}

export async function createMission(mission) {
  const response = await api.post("/missions", mission);
  return response.data;
}